import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './NewPost.css';
import NeighbourSidebar from "../../NeighbourSidebar";
import Header from "../../NeighbourHeaderAfterLogin";
import Footer from "../../FooterAfterLogin";
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';


const NewPost = () => {

    useEffect(() => {
        document.title = `New Post | Local Bells`;
        document.getElementById('bodywrap').className = 'nenewpost';
    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };


    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <NeighbourSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='white-box'>
                                    <Row>
                                        <Col md={12}>
                                            <h3>New Post</h3>
                                            <h6>Select New Post Category</h6>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6} xs={12}>
                                            <Link to="/neighbour/local-question" className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/local-issue.webp'} className="img-fluid np-icn" alt="local-issue" />
                                                    </Col>
                                                    <Col>
                                                        <h6>Local Issue</h6>
                                                        <p>Post your local problems like-Road & Infrastructure Water & Electricity, Cleanliness, many more.</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                        <Col md={6} xs={12}>
                                            <Link to="/neighbour/local-question" className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/questions.webp'} className="img-fluid np-icn" alt="questions" />
                                                    </Col>
                                                    <Col>
                                                        <h6>Questions</h6>
                                                        <p>Ask questions on Locality update, lost and found. housing job opportunity. Government services. School & tutor recommendations. Classes.</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                        <Col md={6} xs={12}>
                                            <Link to="/neighbour/local-question" className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/local-crimes.webp'} className="img-fluid np-icn" alt="local-crimes" />
                                                    </Col>
                                                    <Col>
                                                        <h6>Local Crimes</h6>
                                                        <p>Post on Suspicious activities, women safety, theft. burglary, Frauds, Cyber crimes, Local corruptions. Illegal activities, Riots, Road rage etc.</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                        <Col md={6} xs={12}>
                                            <Link to="/neighbour/add-local-stories" className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/local-highlights.webp'} className="img-fluid np-icn" alt="local-highlights" />
                                                    </Col>
                                                    <Col>
                                                        <h6>Local Highlights</h6>
                                                        <p>Share any informative updates, Interesting facts about your neighborhood.</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                        <Col md={6} xs={12}>
                                            <Link to="/neighbour/local-event" className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/local-events.webp'} className="img-fluid np-icn" alt="local-events" />
                                                    </Col>
                                                    <Col>
                                                        <h6>Local Events</h6>
                                                        <p>Let neighbors know about public events in your neighborhood like Religious Festivals, Charity events Blood donations, Political event, Campaigns, Music. Entertainment, Kids events.</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                        <Col md={6} xs={12}>
                                            <Link to="/neighbour/opinion-survey" className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/opinion-survey.webp'} className="img-fluid np-icn" alt="opinion-survey" />
                                                    </Col>
                                                    <Col>
                                                        <h6>Opinion Survey</h6>
                                                        <p>Seek neighborhood opinion on topics like Local business, govemment policies, Real estate, Infra. Local problems, Health & wellness. Festivals and many more.</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                        <Col md={6} xs={12}>
                                            <Link to="/neighbour/local-question" className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/give-away.webp'} className="img-fluid np-icn" alt="give-away" />
                                                    </Col>
                                                    <Col>
                                                        <h6>Offer Free Give Away</h6>
                                                        <p>Offer free give away of items you no longer used Furniture, Books, Toys. Old Electronic gadgets. Babies stuff.</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                        <Col md={6} xs={12}>
                                            <Link to="/neighbour/local-question" className='np-box'>
                                                <Row className='mx-0'>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/general.webp'} className="img-fluid np-icn" alt="general" />
                                                    </Col>
                                                    <Col>
                                                        <h6>Anything Else/General</h6>
                                                        <p>Share anything else to keep your locality informed.</p>
                                                    </Col>
                                                    <Col xs="auto" className='px-0'>
                                                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/arrow.webp'} className="img-fluid np-arrow" alt="arrow" />
                                                    </Col>
                                                </Row>
                                            </Link>
                                        </Col>
                                    </Row>
                                </div>
                                <div className='footer-main footer'>
                                    <Footer />                                
                                </div>                                  
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}

export default NewPost;


